/**
 * @fileoverview Config estática do frontend para o onboarding: mapeia cada
 * taskKey ao seu ícone (lucide). Os demais metadados (group, deepLink, i18nKey,
 * order, status) vêm do backend em GET /onboarding/progress.
 */

import {
  Bot,
  MessageCircle,
  ArrowRightLeft,
  Users,
  Clock,
  Zap,
  FolderTree,
  Tag,
  KanbanSquare,
  GraduationCap,
  CircleHelp
} from "lucide-react";

export const TASK_ICONS = {
  createAi: Bot,
  connectWhatsapp: MessageCircle,
  transferRule: ArrowRightLeft,
  registerUsers: Users,
  businessHours: Clock,
  quickMessage: Zap,
  sectorsQueues: FolderTree,
  tags: Tag,
  crmBoards: KanbanSquare,
  academy: GraduationCap
};

export const getTaskIcon = key => TASK_ICONS[key] || CircleHelp;

/**
 * Rótulo do CTA conforme o status da tarefa.
 *  pending  -> iniciar
 *  done     -> revisar
 *  skipped  -> retomar
 */
export const ctaStateKey = status => {
  if (status === "done") return "revisar";
  if (status === "skipped") return "retomar";
  return "iniciar";
};
